module.exports = __webpack_public_path__ + "static/media/click.fc3a2731.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/click.mp3
// module id = 397
// module chunks = 0